import type { JSX } from 'react'

import { useUnit } from 'effector-react'
import * as era from '~/core/era'
import { ui } from '~/core/skin'
import { ModuleAppTitle } from '~/features/appearance'
import { STATIC_IDENTIFIERS } from '~/shared/appearance'
import { Skeleton } from '~/shared/ui/components/Skeleton'
import * as eventsModel from './model'

export function Title(): JSX.Element {
  return (
    <ModuleAppTitle
      identifier={STATIC_IDENTIFIERS.EVENT}
      fallbackKey='event_other'
    />
  )
}

const skin = era.skin('routes/events/root')

LiveEventsPage.displayName = 'LiveEventsPage'
export function LiveEventsPage(): JSX.Element {
  const isContentLoading = useUnit(eventsModel.$contentLoading)
  return (
    <ui.SkinContext value={skin}>
      <ui.PageWrapper className='live-events-page flex-column'>
        <Skeleton pageType='grid' isLoading={isContentLoading}>
          <ui.RenderSkin name='eventsTabs' />
          <ui.RenderSkin name='eventsGrid' />
          <ui.RenderSkin name='eventsEmptyPage' />
        </Skeleton>
      </ui.PageWrapper>
    </ui.SkinContext>
  )
}
